<script lang="ts">
  import SectionPrelevementDeliveryDetail from '@/generated/sections/SectionPrelevementDeliveryDetail.vue';
  import Transaction from '@/extend/classes/Transaction';
  import Delivery from '@/generated/classes/Delivery';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { defineComponent, type PropType } from "vue";
  import { isProduction } from '@/framework/base/helpers/Environment';

  export default defineComponent({
    components: {},
    extends: SectionPrelevementDeliveryDetail,
    props: {
      delivery: {
        type: Object as PropType<Delivery>,
        required: true
      }
    },
    data() {
      return {
        lastDeliveryId: 0
      };
    },
    computed: {
      canAdd(): boolean {
        return false;
      },
      headers() {
        if (this.lastDeliveryId != this.delivery.id) {
          this.setLastDeliveryId();
          this.resetActiveFilters();
          this.reloadTable();
        }
        return [
          { text: "Source", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Référence", value: 'reference', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: "Statut", value: 'statut', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      pageLimit(): number {
        return 5;
      },
      deliveryId(): number {
        return this.delivery.id;
      },
      production(): boolean {
        return isProduction();
      }
    },
    methods: {
      getLabel(name: string, item: number, obj: Transaction): string {
        let res = item == 0 || item == null ? '' : item.toString();
        if (name == 'statut') {
          if (obj.statut == TransactionStatuts.PROCESSING) {
            res = 'En traitement';
          } else if (obj.statut == TransactionStatuts.WAITED) {
            res = "Attendu";
          } else if (obj.statut == TransactionStatuts.RECEIVED) {
            res = "Reçu";
          } else if (obj.statut == TransactionStatuts.DELIVERED) {
            res = "Délivré";
          } else if (obj.statut == TransactionStatuts.EMITTED) {
            res = "Emis";
          } else if (obj.statut == TransactionStatuts.PAYED) {
            res = "Payé";
          } else if (obj.statut == TransactionStatuts.BILLED) {
            res = "Facturé";
          } else if (obj.statut == TransactionStatuts.WAITING_REJECT) {
            res = "Délai rejet prélèvement";
          } else if (obj.statut == TransactionStatuts.REJECTED) {
            res = "Rejeté";
          } else if (obj.statut == TransactionStatuts.WAITING_MANDAT) {
            res = "Attente mandat";
          }
        }
        return res;
      },
      setLastDeliveryId() {
        this.lastDeliveryId = this.delivery.id;
      },
      canUpdate(transaction: Transaction): boolean {
        return false;
      },
      defaultFilter(): void {
        this.activeFilters = [];
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.PRELEVEMENT;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "deliveryId";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = this.deliveryId;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      selectItem(event: any, row: any): void {
      },
      getActionColor(transaction: Transaction): string {
        if (transaction.statut == TransactionStatuts.PAYED ||
          transaction.statut == TransactionStatuts.WAITING_REJECT) {
          if (this.production) {
            return '#1D6F42' // vert
          } else {
            return '#1D4ED8' // bleu
          }
        } else {
          return '#F40F02' // rouge
        }
      },
      mdiAction(transaction: Transaction): string {
        if (this.production) {
          return 'fas fa-landmark';
        } else {
          return 'fas fa-ban';
        }
      },
      hasAction(transaction: Transaction): boolean {
        return transaction.statut == TransactionStatuts.PAYED ||
          transaction.statut == TransactionStatuts.WAITING_REJECT ||
          transaction.statut == TransactionStatuts.REJECTED;
      },
      execAction(transaction: Transaction): void {
        if (!this.production) {
          this.actionProgress = true;
          Transaction.simuBank([transaction]).then(() => {
            this.actionProgress = false;
          }).catch(() => {
            this.actionProgress = false;
          });
        }
      }
    }
  })

</script>
